var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c_canvas"},[_c('div',{ref:"canvas_container",staticClass:"canvas_container"},[_c('canvas',{ref:"canvas",staticClass:"board"})])])}
var staticRenderFns = []

export { render, staticRenderFns }